import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { getDiscount } from '@shared/jp/discount/utils';
import { DiscountService } from '@studiobuki/web-core/lib/discount';
import type { IBookPreview } from '@shared/jp/data/products';

@Component({
  selector: 'app-book[book]',
  templateUrl: './book.component.html',
  styleUrls: ['./book.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookComponent {
  @Input() book!: IBookPreview | Readonly<IBookPreview>;

  @Output() buttonClick = new EventEmitter<void>();

  public readonly getBooksDiscount = getDiscount;

  constructor(public discountService: DiscountService) {}

  public onButtonClick() {
    this.buttonClick.emit();
  }
}
